import React, {useState, useEffect, useRef} from 'react';
import Button from '../Button/Button';

const TextArea = ({value: _val, onSubmit, onChange, prompt, isDisabled, leftButtons, centerButtons, rightButtons, submitLabel}) => {

    const [value, setValue] = useState(_val ?? '');
    const [textAreaHeight, setTextAreaHeight] = useState('50px');
    const [defaultSubmitting, setDefaultSubmitting] = useState(false);
    const fieldRef = useRef();

    useEffect(() => {
        if (!fieldRef?.current) {
            return;
        }
        setTextAreaHeight(Math.max(70, fieldRef.current.scrollHeight) + 'px');
    }, [value])

    useEffect(() => {
        setValue(_val);
    }, [_val])

    const handleChange = (value) => {
        setValue(value);
        onChange && onChange(value);
    }

    const handleSubmit = async (e) => {
        setDefaultSubmitting(true);
        e.preventDefault();
        await onSubmit(value)
        setDefaultSubmitting(false);
    }

    return <form className="relative" onSubmit={handleSubmit}>
        <div className="overflow-hidden rounded-lg shadow-xs ring-1 ring-inset ring-gray-300 focus-within:ring-2 focus-within:ring-brand">
            <label htmlFor="comment" className="sr-only">
                {prompt}
            </label>
            <textarea
                ref={fieldRef}
                name="comment"
                id="comment"
                className="block w-full resize-none border-0 py-1.5 bg-transparent focus:ring-0 sm:text-sm sm:leading-6"
                style={{height: textAreaHeight}}
                placeholder={prompt}
                value={value}
                onChange={(e) => handleChange(e.target.value)}
                disabled={isDisabled || defaultSubmitting}
            />

            <div className="inset-x-0 bottom-0 flex justify-between pl-3 pr-2">
                <div className="flex items-center space-x-5">
                    <div className="flex items-center">
                        {leftButtons}
                    </div>
                    <div className="flex items-center">
                        {centerButtons}
                    </div>
                </div>
                <div className="shrink-0">
                    {rightButtons}
                    {submitLabel && <Button
                        type="submit"
                        theme="primary"
                        disabled={defaultSubmitting}
                        loading={defaultSubmitting}
                        label={submitLabel}
                    />}
                </div>
            </div>
        </div>
    </form>
}

export default TextArea;
